import { call, put, select, takeLatest, fork } from 'redux-saga/effects';

import {
  setLoadingState,
  queryUnpaidTuitionCostInLoanCurrencySuccess,
  queryUnpaidTuitionCostInLoanCurrencyError,
  addPageData,
  navigateWizard,
} from '../actions';
import PeriodsAPI from '../api/PeriodsAPI';
import { QUERY_UNPAID_TUITION_COST_IN_LOAN_CURRENCY_REQUEST } from '../constants/actionTypes';
import * as payloadFactory from '../lib/pageDataPayloadFactory';
import {
  buildServerSelector,
  accessTokenSelector,
  unpaidTuitionCostSelector,
} from '../reducers/selectors';

import { manageAPIError } from './helpers/errorHelper';

function* unpaidTuitionCostLoanCurrencyAmountWatcher() {
  yield takeLatest(
    QUERY_UNPAID_TUITION_COST_IN_LOAN_CURRENCY_REQUEST,
    unpaidTuitionCostLoanCurrencyAmountWorker,
  );
}

function* unpaidTuitionCostLoanCurrencyAmountWorker(action) {
  try {
    const accessToken = yield select(accessTokenSelector);
    const builder = yield select(buildServerSelector);
    const unpaidTuitionCost = yield select(unpaidTuitionCostSelector);
    yield put(setLoadingState(true));
    const response = yield call(PeriodsAPI.calculateCostInLoanCurrency, builder, accessToken);
    yield put(queryUnpaidTuitionCostInLoanCurrencySuccess(response));
    yield put(setLoadingState(false));

    const unpaidTuitionCostPayload = yield call(
      payloadFactory.createAddPageDataPayload,
      'unpaidTuitionCost',
      {
        loanCurrency: response.loanCurrency,
        loanAmount: response.loanAmount,
        schoolCurrency: unpaidTuitionCost.schoolCurrency,
        schoolAmount: unpaidTuitionCost.schoolAmount,
      },
    );
    yield put(addPageData(unpaidTuitionCostPayload));

    yield put(navigateWizard({ dir: 'fwd' }));
  } catch (error) {
    yield put(queryUnpaidTuitionCostInLoanCurrencyError());
    yield fork(manageAPIError, { ...error, action });
    yield put(setLoadingState(false));
  }
}

export { unpaidTuitionCostLoanCurrencyAmountWorker };
export default unpaidTuitionCostLoanCurrencyAmountWatcher;
